
import { auth, googleProvider  } from '@/fireinit'

const state = {
    // user: null
}

const mutations = {

}

const actions = {
    async sendEmailVerification() {
        try {
            const actionCodeSettings = {
                url: process.env.VUE_APP_EMAIL_VERIFICATION_CONTINUE_URL
            }
            await auth.currentUser.sendEmailVerification(actionCodeSettings)
        } catch (error) {
            throw error
        }
    },
    async signIn(_, account) {
        try {
            await auth.signInWithEmailAndPassword(account.email, account.password)
        } catch (error) {
            throw error
        }
    },
    async googleSignIn() {
        try {
            await auth.signInWithRedirect(googleProvider)
        } catch (error) {
            throw error
        }
    },
    // async fbSignIn() {
    //     try {
    //         await auth.signInWithRedirect(fbProvider)
    //     } catch (error) {
    //         throw error
    //     }
    // },
    async signOut() {
        // commit('ui/SET_LOADING', true, { root: true })
        try {
            await auth.signOut()
            location.reload()
        } catch (error) {
            throw error
        }
    },
    async resetPw(_, email) {
        try {
            await auth.sendPasswordResetEmail(email)
        } catch (error) {
            throw error
        }
    },

    async signInAnonymously({commit}) {
    commit('ui/SET_LOADING', true, { root: true })
        try {
            await auth.signInAnonymously()
        } catch (error) {
            throw error
        }
    },

}

const getters = {
    // user(state) {
    //     return state.user
    // },
    // isAuthenticated(state) {
    //     return state.user.email !== null
    // }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}